export default "/static/dashboard/build/app/img/v2/95f9c03c412e809dcc4bb6188056e06d.png";